import styled from 'styled-components';
import colors from '../../../../includes/colors';

export const ContactInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;

export const ContactInfoLink = styled.a`
  color: ${colors.blue};
  font-size: 1rem;
`;

export const ContactInfoSide = styled.div`
  margin-right: .7rem;
  display: flex;
  align-self: ${props => props.align || 'center'};
`;

export const ContactInfoAddress = styled.div`
  font-size: .9rem;
`;

export const ContactInfoAddressTitle = styled.h4`
  font-weight: bold;
  font-size: .9rem;
  margin-bottom: .1rem;
`;
export const ContactInfoAddressDescription = styled.p``;

export const ContactInfoAddressWarning = styled.i``;
